import React from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import ButtonLink from '../Buttons/ButtonLink'

const NotFound = (): JSX.Element => {
  const navigate = useNavigate()

  return (
    <>
      <Header />
      <div className='not-found-container'>
        <h1>404</h1>
        <h2>Strona Nie Została Znaleziona</h2>
        <p>Przepraszamy, strona której szukasz nie istnieje lub została przeniesiona.</p>

        <ButtonLink
          to='/'
          onClick={() => navigate('/')}
        >
          Powrót Na Stronę Główną
        </ButtonLink>
      </div>
      <Footer />
    </>
  )
}

export default NotFound
